import { SxProps } from "@mui/material";

export const customStepperStyle: SxProps = {
  my: 1.5,
  "& .MuiStepConnector-line": {
    borderLeftWidth: 2,
    color: "#D8DBE4",
  },
  "& .MuiStepLabel-root": {
    p: 0,
    ml: 1,
  },
  ml: "5px",
};

export const customSidebarStyle: SxProps = {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
};

export const CustomModalStepWrapper: SxProps = {
  mb: 3,
  "& .MuiStepConnector-root": {
    display: "none",
  },
  "& .MuiStep-root": {
    width: "50%",
  },
};

export const CustomModalStepStyle: SxProps = {
  "& .MuiSvgIcon-root.Mui-completed": {
    color: "#70AE71",
  },
  "& .MuiSvgIcon-root.Mui-active": {
    color: "primary.main",
  },
  "& .MuiStepIcon-root": {
    height: "34px",
    width: "34px",
  },
  "& .MuiStepLabel-label": {
    fontSize: "18px",
    fontWeight: "500",
  },
};
